import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.open();
    }
  };

  open() {
    try {
      if (typeof this.showDialogPop === 'function') {
        this.showDialogPop();
      } else {
        this.showDialog();
      }
    } catch (error) {
      console.warn('[cart-drawer] theme open failed', error);
    }

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });

    if (typeof renderPopPrices === 'function') renderPopPrices();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}